import useSWR from "swr"
import {API_LEXICONS} from "../constants/apiUrls"

export default function useLexicons() {
    const {data, mutate, error} = useSWR(API_LEXICONS)
    return {
        lexicons: data,
        mutateLexicons: mutate,
        isLoadingLexicons: !error && !data,
        isErrorLexicons: error
    }
}